import { render, staticRenderFns } from "./EstadisticasGenerales.vue?vue&type=template&id=7bccf558&"
import script from "./EstadisticasGenerales.vue?vue&type=script&lang=js&"
export * from "./EstadisticasGenerales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports